export { GlobalErrorBoundary } from './src/global-error-boundary';
